export var mapEvaluations = function mapEvaluations(evaluations) {
  return {
    averageRating: parseFloat(evaluations.averageRating),
    overallNumberOfEvaluations: evaluations.overallNumberOfEvaluations,
    ownerRecommendationsPercentage: evaluations.ownerRecommendationsPercentage,
    evaluationSwitchStatusText: evaluations.evaluationSwitchStatusText
  };
};